import { useEffect } from "react";
import groupBy from "lodash/groupBy";
import debounce from "lodash/debounce";
export default function useEqualRowHeight(container, attribute, dependencies = []) {
    useEffect(() => {
        handleChange(container, attribute);
    }, [container.current, ...dependencies]);
    useEffect(() => {
        const onChange = debounce(() => handleChange(container, attribute), 100);
        window.addEventListener("resize", onChange);
        return () => {
            window.removeEventListener("resize", onChange);
        };
    }, []);
}
function handleChange(container, attribute) {
    if (!container.current) {
        return;
    }
    const cells = [...container.current.querySelectorAll(`[${attribute}]`)];
    const rows = groupBy(cells, (cell) => cell.getAttribute(attribute));
    Object.values(rows).forEach(equalizeRow);
}
function equalizeRow(cells) {
    let maxHeight = 0;
    for (const cell of cells) {
        cell.style.height = "auto";
        const rect = cell.getBoundingClientRect();
        maxHeight = Math.max(rect.height, maxHeight);
    }
    for (const cell of cells) {
        cell.style.height = `${maxHeight}px`;
    }
}
